<template>
  <div>
    <v-card :disabled='disabled' v-for='(item,index) of contracts' :key='index' class='mt-4'>
      <v-card-text>
        <v-card-title>Контракт номер: {{ item.Number || '' }}</v-card-title>
        <v-row>
          <!-- contract -->
          <v-col cols='12' sm='2' md='2'>
            <v-text-field v-model='item.Number' outlined dense label='Номер контракта'></v-text-field>
          </v-col>
          <v-col cols='12' sm='2' md='2'>
            <oil-date-picker
                :item='item'
                item-key='StartDate'
                :keys='startDateKeys'
                :vInput='input'
                v-model='item.StartDate'
                :attr='startDateKeys.attrs'
            />
          </v-col>
          <v-col cols='12' sm='2' md='2'>
            <oil-date-picker
                item-key='EndDate'
                :item='item'
                v-model='item.EndDate'
                :keys='endDateKeys'
                :vInput='input'
                :attr='endDateKeys.attrs'
            />
          </v-col>
          <v-col cols='12' sm='2' md='2'>
            <v-text-field v-model='item.Price' outlined dense label='Сумма в долларах США' type='number'
                          :rules='required'></v-text-field>
          </v-col>
          <v-col cols='12' sm='2' md='2'>
            <File :item='item' :importer='data'/>
            <!-- <v-file-input @change='setFile' outlined dense label='Загрузить файл' />&ndash;&gt;-->
          </v-col>
          <v-col cols='12' sm='1' md='1' class='text-right'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on, attrs }'>
                <v-btn style='box-shadow: none;color: #00b24f;background-color: transparent' :disabled='!input.isEdit'
                       @click='dow(item)'
                       v-bind='attrs'
                       v-on='on'
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Скачать</span>
            </v-tooltip>
          </v-col>
          <v-col cols='12' sm='1' md='1'>
            <template>
              <v-row justify="center">
                <v-dialog
                    v-model="dialog"
                    persistent
                    max-width="300"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="red"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        icon
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <v-card class='pt-4'>
                    <v-card-text>вы точно хотите удалить этот документ ?</v-card-text>
                    <v-card-actions>
                      <v-btn
                          color="green darken-1"
                          text
                          @click="removeContract(index,item)"
                      >
                        Подтвердить
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                          color="green darken-1"
                          text
                          @click="dialog = false"
                      >
                        Отменить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

          </v-col>

          <v-card-subtitle>Дополнительные предложений: {{ item.Appendixes.length || 0 }}</v-card-subtitle>
          <v-col cols='12'>

            <v-btn outlined dense color='green' @click='appendixPlus(item)' class='mb-5'>Добавить предложений</v-btn>

            <Child1
                :items='item.Appendixes'
                :importer='data'
            />
          </v-col>
          <v-card-subtitle>Предложений сертификации: {{ item.Certifications.length || 0 }}</v-card-subtitle>
          <!--        certifications-->
          <v-col cols='12'>
            <v-btn outlined dense color='green' @click='certificationsPlus(item)' class='mb-5'>Добавить сертификации
            </v-btn>

            <Child2
                :items='item.Certifications'
                :importer='data'
            />
          </v-col>
        </v-row>
        <hr/>
        <hr/>
      </v-card-text>
    </v-card>
  </div>


</template>

<script>
import File from '~/pages/importer/settng/File'
import {coreApi} from '~/services/core'

export default {
  name: 'contend',
  props: {
    data: Object,
    item: Array,
    disabled: Boolean,
  },

  components: {
    File,
    Child1: () => import('./ContractChild'),
    Child2: () => import('./Certifications'),
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal')
  },
  data() {
    return {
      required: [
        v => !!v || 'Поле обязательно для ввода'
      ],
      dialog: false,
      appendixCount: 1,
      certificationCount: 1,
      startDateKeys: {
        attrs: {
          readonly: false,
          outlined: true,
          dense: true,
          label: 'Дата начало'
        }
      },
      endDateKeys: {
        attrs: {
          readonly: false,
          outlined: true,
          dense: true,
          label: 'Дата конец'
        }
      },
      input: {isEdit: true}
    }
  },
  created() {
    this.item ??= []
  },
  computed: {
    contracts() {
      return this.item
    }
  },
  methods: {
    /**
     * @param {File} file
     */
    async setFile(file) {
    },
    certificationsPlus(i) {
      i.Certifications.push({
        Number: '',
        StartDate: '',
        EndDate: '',
        Price: 0
      })
    },
    appendixPlus(i) {
      i.Appendixes.push({
        Number: '',
        StartDate: '',
        EndDate: '',
        Price: 0
      })
    },
    async accept(index) {

    },
    async removeContract(index, item) {
      const data = this.data
      if (item.Attachment) {
        await coreApi.delete(`file/${item.Attachment.Id}`)
        this.item.splice(index, 1)
        await coreApi.put('/importer', data)
      } else {
        this.item.splice(index, 1)
        await coreApi.put('/importer', data)
      }
      this.dialog = false
    }
  }
}
</script>